/**
 * @generated SignedSource<<d497686c6ee9cc4e7831bf1d50412726>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
import { FragmentRefs } from "relay-runtime";
export type DepartmentCard_department$data = {
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly type: DepartmentType;
  readonly " $fragmentType": "DepartmentCard_department";
};
export type DepartmentCard_department$key = {
  readonly " $data"?: DepartmentCard_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentCard_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentCard_department",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "a04c61220d30c9dbd12be5ee9ef3b9b6";

export default node;
